import { render } from "./IntroAnimation.vue?vue&type=template&id=087f12d6&scoped=true"
const script = {}

import "./IntroAnimation.vue?vue&type=style&index=0&id=087f12d6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mm\\Documents\\__Kundenprojekte\\ÜIM-HAB\\Entwicklung\\Frontend\\uebersetzen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087f12d6"]])

export default __exports__